import { usePermission } from "@iotos/ims-auth-sdk/permissions";

/**
 * Весь словарь прав, который IMS выдаёт EkoCrop, — две строки: `web:view`
 * и `web:edit`. Более дробного деления (прежние роли admin/manager/user)
 * в IMS нет, поэтому гейты чтения сведены к `view`, гейты записи — к `edit`.
 */
const WEB_SUBJECT = "web";

/** Доступ к веб-приложению на просмотр. */
export function useCanViewWeb(): boolean {
  return usePermission("view", WEB_SUBJECT);
}

/** Право менять данные из веб-приложения. */
export function useCanEditWeb(): boolean {
  return usePermission("edit", WEB_SUBJECT);
}
